var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import MuiOutlinedInput from "@material-ui/core/OutlinedInput";
import { InputActions } from "../input-actions";
import { makeStyles } from "../styles";
import { getCosmosDataProps } from "../utils/comsosCompat";
import { InputAdornment } from "../input-adornment";
export var getMaskedInputProps = function (masked, inputProps) {
    var maskedProps = {};
    if (masked) {
        var maskedValueKey = !!inputProps.value ? "value" : "defaultValue";
        var length_1 = inputProps[maskedValueKey] ? String(inputProps[maskedValueKey]).length : 8;
        maskedProps.placeholder = new Array(length_1 + 1).join("•");
        maskedProps.disabled = true;
        maskedProps[maskedValueKey] = "";
    }
    return maskedProps;
};
export var useInputStyles = makeStyles(function (theme) { return ({
    inputCode: __assign(__assign({}, theme.typography.code1), { "&:not($inputCodeMultiline)": {
            lineHeight: theme.typography.input.lineHeight,
        } }),
    inputCodeMultiline: {},
}); }, { name: "CosmosInput" });
export var Input = React.forwardRef(function (props, ref) {
    var classes = useInputStyles(props);
    var actions = props.actions, code = props.code, masked = props.masked, multiline = props.multiline, _a = props.inputProps, inputPropsProp = _a === void 0 ? {} : _a, min = props.min, max = props.max, readOnly = props.readOnly, disabled = props.disabled, size = props.size, margin = props.margin, suffix = props.suffix, endAdornmentProp = props.endAdornment, 
    // remove to prevent passing through to the root
    propClasses = props.classes, rootProps = __rest(props, ["actions", "code", "masked", "multiline", "inputProps", "min", "max", "readOnly", "disabled", "size", "margin", "suffix", "endAdornment", "classes"]);
    var endAdornment = endAdornmentProp ||
        (actions && React.createElement(InputActions, { multiline: multiline, actions: actions })) ||
        (suffix && React.createElement(InputAdornment, { position: "end" }, suffix));
    var maskedProps = getMaskedInputProps(masked, rootProps);
    var inputProps = __assign(__assign({ min: min,
        max: max,
        readOnly: readOnly }, inputPropsProp), getCosmosDataProps(multiline ? "text-area" : "text-input"));
    return (React.createElement(MuiOutlinedInput, __assign({ classes: {
            input: code ? classes.inputCode : undefined,
            inputMultiline: code ? classes.inputCodeMultiline : undefined,
        }, margin: size === "small" ? "dense" : margin, disabled: disabled || readOnly, multiline: multiline, endAdornment: endAdornment, inputProps: inputProps }, rootProps, maskedProps, { ref: ref })));
});
